import React from 'react'
import { IProduct } from '@core/api/Products/types'
import { useRelatedProducts } from '@core/components/ProductDetail/useRelatedProducts'
import { useTranslation } from '@core/i18n/i18n'
import { useProductDetailContext } from '@core/utils/models/product/ProductContext'
import ProductRelationBase from '@core/components/ProductDetail/ProductRelations/ProductRelationBase'

const useCrossSellProducts = (product?: IProduct) => {
  const { relatedProducts } = useRelatedProducts(product, 'crossSell')
  return relatedProducts
}

const CrossSellProductRelations: React.FC = () => {
  const { t } = useTranslation()
  const { product } = useProductDetailContext() || {}
  const crossSellProducts = useCrossSellProducts(product)

  return (
    <ProductRelationBase
      title={t`productDetail.crossSell.title`}
      products={crossSellProducts}
    />
  )
}

export default CrossSellProductRelations
